import React from "react";
import Footer from "../../components/Footer";
import { TopAccountBar } from "../../components/InfoBar/components/TopAccountBar/TopAccountBar.view";
import { useAppSelector } from "../../redux/hook";
import Spinner from "../../components/Spinner";
import { getColors, getFullAddressFormatted } from "../../utils";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Container,
  Divider,
} from "@mui/material";

const Section = ({ title, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: 4,
      mb: 3,
      borderRadius: 1,
      border: "1px solid",
      borderColor: "divider",
      background: getColors().bgwhite,
      backdropFilter: "blur(6px)",
      boxShadow: "none",
    }}
  >
    <Typography
      variant="subtitle1"
      fontWeight={700}
      sx={{
        mb: 2,
        position: "relative",
        pl: 1.5,
        "&:before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 4,
          bottom: 4,
          width: 3,
          borderRadius: 2,
          backgroundColor: "primary.main",
        },
      }}
    >
      {title}
    </Typography>

    <Stack spacing={1} sx={{ color: "text.secondary", lineHeight: 1.7 }}>
      {children}
    </Stack>
  </Paper>
);

export default function LegalNotices() {
  const { servicePrice } = useAppSelector(
    (state) => state.configurationReducer
  );
  const { legal } = useAppSelector((state) => state.shopReducer);

  const legalResult = servicePrice?.legal || legal;

  return (
    <>
      <TopAccountBar />

      <Box
        sx={{
          minHeight: "100vh",
          background: getColors().bglightgrey,
          py: 6,
          transition: "all 0.2s ease",
        }}
      >
        <Container maxWidth="md">
          {legalResult ? (
            <>
              <Box sx={{ mb: 5, textAlign: "center" }}>
                <Typography variant="h3" fontWeight={800} color={getColors().text} gutterBottom>
                  Mentions Légales
                </Typography>

                <Typography variant="body2" color={getColors().text}>
                  Informations juridiques et administratives
                </Typography>
              </Box>

              <Section
                title={`Informations légales de ${legalResult.companyName}`}
              >
                <Typography>
                  <strong>Siège social :</strong>{" "}
                  {getFullAddressFormatted(legalResult.address)}
                </Typography>

                <Typography>
                  <strong>SIREN :</strong> {legalResult.registreCommerceNumero}
                </Typography>

                <Typography>
                  <strong>Directeur de publication :</strong>{" "}
                  {legalResult.companyName}
                </Typography>
              </Section>

              <Section title="Conception et réalisation">
                <Typography>
                  <strong>Crédit :</strong> Dishop
                </Typography>

                <Typography>
                  <strong>Siège social :</strong> 38 bis boulevard Victor Hugo,
                  06000 Nice
                </Typography>

                <Typography>
                  <strong>SIREN :</strong> 879 912 806
                </Typography>

                <Typography>
                  <strong>Hébergement :</strong> Google Cloud & AWS
                </Typography>
              </Section>

              <Divider sx={{ my: 4 }} />

              <Typography
                variant="caption"
                color={getColors().text}
                display="block"
                textAlign="center"
              >
                Dernière mise à jour : {new Date().getFullYear()}
              </Typography>
            </>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="40vh"
            >
              <Spinner />
            </Box>
          )}
        </Container>
      </Box>

      <Footer />
    </>
  );
}